import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ShieldOff, SearchX } from 'lucide-react';
import { Button } from '@/components/ui/button';

function Shell({
  icon,
  title,
  description,
}: {
  icon: ReactNode;
  title: string;
  description: string;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60svh] flex-col items-center justify-center gap-4 text-center">
      <span className="bg-muted text-muted-foreground flex size-14 items-center justify-center rounded-full">
        {icon}
      </span>
      <div className="space-y-1">
        <h2 className="text-xl font-semibold">{title}</h2>
        <p className="text-muted-foreground max-w-sm text-sm">{description}</p>
      </div>
      <Button variant="outline" asChild>
        <Link to="/dashboard">
          <ArrowLeft />
          {t('common.backToDashboard')}
        </Link>
      </Button>
    </div>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Shell
      icon={<SearchX className="size-7" />}
      title={t('pages.notFound.title')}
      description={t('pages.notFound.body')}
    />
  );
}

export function UnauthorizedPage() {
  const { t } = useTranslation();
  return (
    <Shell
      icon={<ShieldOff className="size-7" />}
      title={t('pages.unauthorized.title')}
      description={t('pages.unauthorized.body')}
    />
  );
}
